let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = Promise.all([load("1ZAFx"), load("ffEVr"), load("bXHUH")]).then(() => parcelRequire('4dpqU'));